export default "__VITE_ASSET__DlSd2TB8__"